import { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { slugs } from "../../const/slugs";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import SwapHorizRoundedIcon from "@mui/icons-material/SwapHorizRounded";
import PeopleRoundedIcon from "@mui/icons-material/PeopleRounded";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import WallpaperRoundedIcon from "@mui/icons-material/WallpaperRounded";
import HandshakeRoundedIcon from "@mui/icons-material/HandshakeRounded";
import GavelRoundedIcon from "@mui/icons-material/GavelRounded";
import BugReportRoundedIcon from "@mui/icons-material/BugReportRounded";

export const DrawerContainer = () => {
  const [currentLink, setCurrentLink] = useState<string>("/");
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname.split("/")[1]) {
      setCurrentLink("/");
    } else {
      setCurrentLink(location.pathname.split("/")[1]);
    }
  }, [location?.pathname]);

  const links = useMemo(
    () => [
      {
        url: slugs.dashboard,
        name: "Dashboard",
        activate: currentLink === "/",
        icon: <DashboardRoundedIcon fontSize="small" />,
      },
      {
        url: slugs.transactions,
        name: "Transactions",
        activate: currentLink === "transactions",
        icon: <SwapHorizRoundedIcon fontSize="small" />,
      },
      {
        url: slugs.users,
        name: "User List",
        activate: currentLink === "users",
        icon: <PeopleRoundedIcon fontSize="small" />,
      },
      {
        url: slugs.flipNFTs,
        name: "All Collections",
        activate: currentLink === "flip-nfts",
        icon: <GridViewRoundedIcon fontSize="small" />,
      },
      {
        url: slugs.transactionnft,
        name: "Transaction NFT",
        activate: currentLink === "transactionnft",
        icon: <ReceiptLongRoundedIcon fontSize="small" />,
      },
      {
        url: slugs.reward,
        name: "Reward NFTs",
        activate: currentLink === "reward",
        icon: <EmojiEventsRoundedIcon fontSize="small" />,
      },
      // {
      //   url: slugs.createNftManual,
      //   name: "Create NFTs Manual",
      //   activate: currentLink === "create-nft-manual",
      //   icon: <AddCircleRoundedIcon fontSize="small" />,
      // },
      // {
      //   url: slugs.backgrounds,
      //   name: "Backgrounds",
      //   activate: currentLink === "backgrounds",
      //   icon: <WallpaperRoundedIcon fontSize="small" />,
      // },
      {
        url: slugs.sponsors,
        name: "Sponsors",
        activate: currentLink === "sponsors",
        icon: <HandshakeRoundedIcon fontSize="small" />,
      },
      {
        url: slugs.policies,
        name: "Policies",
        activate: currentLink === "policies",
        icon: <GavelRoundedIcon fontSize="small" />,
      },
      {
        url: slugs.reports,
        name: "Reports",
        activate: currentLink === "reports",
        icon: <BugReportRoundedIcon fontSize="small" />,
      },
    ],
    [currentLink]
  );

  return (
    <div className="h-full bg-ninth flex flex-col overflow-y-auto">
      <div className="flex justify-center">
        <img
          src="/resource/images/Logo.png"
          alt="Logo"
          className="mt-[62px] mb-[48px] cursor-pointer"
        />
      </div>
      <nav className="flex-1 px-4">
        <p className="text-[11px] font-Raleway800 uppercase tracking-[0.25em] mb-4 pl-3 text-fifth opacity-50">
          Menu
        </p>
        <ul className="w-full flex flex-col gap-2">
          {links.map((link, index) => (
            <li key={index}>
              <Link
                to={link.url}
                className={`drawer-link${link.activate ? " drawer-link-active" : ""}`}
              >
                <span className="drawer-link-icon">{link.icon}</span>
                <span>{link.name}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};
